<!--完善资料弹框-->
<template>
  <div class="perfect-container">
    <!-- 完善资料 -->
    <van-dialog
      v-model="perfectShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'3.36rem'"
    >
      <template #default>
        <div v-if="isPc" class="perfect-content-pc">
          <div class="title">{{content.perfect}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <el-form class="maxHeight70 login-form-p beauty-scroll">
            <el-form-item v-if="lanuage == 'Chinese'" :label="content.selectTypeLabel">
              <el-select v-model="perfectForm.code" :placeholder="content.selectType" @change="pcTypeChange">
                <el-option
                  v-for="item in columns"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="content.loginNameLabel">
              <el-input
                v-model="perfectForm.name"
                :maxlength="15"
                :placeholder="content.loginNameTip">
              </el-input>
            </el-form-item>
            <el-form-item v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectHospitalLabel">
              <el-select
                v-model="perfectForm.hospital_name"
                filterable
                allow-create
                remote
                clearable
                :placeholder="content.selectHospital"
                :loading="pcHospitalLoading"
                :remote-method="pcHospitalRemoteMethod"
                @clear="pcHospitalClear"
                @focus="pcHospitalFocus">
                <el-option
                  v-for="item in pcHospitalColumns"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="lanuage != 'Chinese'" :label="content.loginCompanyLabel">
              <el-input
                v-model="perfectForm.hospital_name"
                :placeholder="content.loginCompanyTip">
              </el-input>
            </el-form-item>
            <el-form-item v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectOfficeLabel">
              <el-cascader v-model="officesFormData" :options="officesList" :placeholder="content.selectOffice" :show-all-levels="false" @change="selectOfficeChange"></el-cascader>
            </el-form-item>
            <el-form-item v-if="lanuage != 'Chinese'" :label="content.loginOfficeLabel">
              <el-input
                v-model="perfectForm.hospital_offices"
                :placeholder="content.loginOfficeTip">
              </el-input>
            </el-form-item>
            <el-form-item v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectJobTitleLabel">
              <el-select v-model="perfectForm.job_title" :placeholder="content.selectJobTitle">
                <el-option
                  v-for="item in jobTitleList"
                  :key="item.id"
                  :label="item.job_title"
                  :value="item.job_title">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectSchoolLabel">
              <el-select
                v-model="perfectForm.school"
                filterable
                remote
                clearable
                :placeholder="content.selectSchool"
                :loading="pcSchoolLoading"
                :remote-method="pcSchoolRemoteMethod"
                @clear="pcSchoolClear"
                @focus="pcSchoolFocus">
                <el-option
                  v-for="item in pcSchoolColumns"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectSpecialtyLabel">
              <el-input
                v-model="perfectForm.specialty"
                :maxlength="15"
                :placeholder="content.selectSpecialty">
              </el-input>
            </el-form-item>
            <el-form-item v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectEducationLabel">
              <el-select v-model="perfectForm.education" :placeholder="content.selectEducation">
                <el-option
                  v-for="item in educationList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectUnitLabel">
              <el-input
                v-model="perfectForm.work_unit"
                :maxlength="30"
                :placeholder="content.selectUnit">
              </el-input>
            </el-form-item>
            <el-form-item v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type) && lanuage == 'Chinese'" :label="content.selectPostLabel">
              <el-input
                v-model="perfectForm.post"
                :maxlength="20"
                :placeholder="content.selectPost">
              </el-input>
            </el-form-item>
          </el-form>
          <!-- <van-field
            v-model="perfectForm.password"
            type="password"
            size="small"
            maxlength="15"
            placeholder="请输入密码"
            :error-message="passwordErrorMessage"
            @input="passwordInput"
          />
          <van-field
            v-model="perfectForm.passwordModify"
            type="password"
            size="small"
            maxlength="15"
            placeholder="请输入确认密码"
            :error-message="passwordModiErrorMessage"
            @input="passwordModiInput"
          /> -->
          <div class="perfect-tip">{{ content.perfectTip }}</div>
          <van-button
            type="info"
            round
            class="perfectBtn"
            :disabled="!validForm"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="perfectBtn"
          >{{content.submit}}</van-button>

        </div>
        <div v-else class="perfect-content">
          <div class="title">{{content.perfect}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <van-field
            v-if="lanuage == 'Chinese'"
            readonly
            clickable
            v-model="perfectForm.type"
            size="small"
            :placeholder="content.selectType"
            right-icon="arrow-down"
            @click="showPicker = true"
          />
          <van-field
            v-model="perfectForm.name"
            size="small"
            maxlength="15"
            :placeholder="content.loginNameTip"
          />
          <van-field
            v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'"
            readonly
            clickable
            v-model="perfectForm.hospital_name"
            size="small"
            maxlength="30"
            :placeholder="content.selectHospital"
            right-icon="arrow-down"
            @click="showHospitalPicker = true"
          />
          <van-field
            v-if="lanuage != 'Chinese'"
            v-model="perfectForm.hospital_name"
            size="small"
            :placeholder="content.loginCompanyTip"
          />
          <van-field
            v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'"
            readonly
            clickable
            v-model="perfectForm.hospital_offices"
            size="small"
            maxlength="20"
            :placeholder="content.selectOffice"
            right-icon="arrow-down"
            @click="showOfficesPicker = true"
          />
          <van-field
            v-if="lanuage != 'Chinese'"
            v-model="perfectForm.hospital_offices"
            size="small"
            maxlength="15"
            :placeholder="content.loginOfficeTip"
          />
          <van-field
            v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type) && lanuage == 'Chinese'"
            readonly
            clickable
            v-model="perfectForm.job_title"
            size="small"
            maxlength="15"
            :placeholder="content.selectJobTitle"
            right-icon="arrow-down"
            @click="showJobTitlePicker = true"
          />
          <van-field
            v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'"
            readonly
            clickable
            v-model="perfectForm.school"
            size="small"
            maxlength="20"
            :placeholder="content.selectSchool"
            right-icon="arrow-down"
            @click="showSchoolPicker = true"
          />
          <van-field
            v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'"
            v-model="perfectForm.specialty"
            size="small"
            maxlength="15"
            :placeholder="content.selectSpecialty"
          />
          <van-field
            v-if="['医学生'].includes(perfectForm.type) && lanuage == 'Chinese'"
            readonly
            clickable
            v-model="perfectForm.education"
            size="small"
            maxlength="10"
            :placeholder="content.selectEducation"
            right-icon="arrow-down"
            @click="showEducationPicker = true"
          />
          <van-field
            v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type) && lanuage == 'Chinese'"
            v-model="perfectForm.work_unit"
            size="small"
            maxlength="30"
            :placeholder="content.selectUnit"
          />
          <van-field
            v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type) && lanuage == 'Chinese'"
            v-model="perfectForm.post"
            size="small"
            maxlength="20"
            :placeholder="content.selectPost"
          />
          <!-- <van-field
            v-model="perfectForm.password"
            type="password"
            size="small"
            maxlength="15"
            placeholder="请输入密码"
            :error-message="passwordErrorMessage"
            @input="passwordInput"
          />
          <van-field
            v-model="perfectForm.passwordModify"
            type="password"
            size="small"
            maxlength="15"
            placeholder="请输入确认密码"
            :error-message="passwordModiErrorMessage"
            @input="passwordModiInput"
          /> -->
          <div class="perfect-tip">{{ content.perfectTip }}</div>
          <van-button
            type="info"
            round
            class="perfectBtn"
            :disabled="!validForm"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="perfectBtn"
          >{{content.submit}}</van-button>

        </div>
      </template>
    </van-dialog>
    <!--身份选择框-->
    <van-popup
      v-model="showPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        :columns="columns"
        value-key="name"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <!--科室选择框-->
    <van-popup
      v-model="showOfficesPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        :columns="officesList"
        value-key="title"
        @change="onOfficesChange"
        @confirm="onOfficesConfirm"
        @cancel="showOfficesPicker = false"
      />
    </van-popup>
    <!--医院选择框-->
    <van-popup
      v-model="showHospitalPicker"
      position="bottom"
    >
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="hospitalCancel">{{content.becancel}}</button>
        <!-- <button type="button" class="van-picker__confirm"></button> -->
      </div>
      <van-search v-model="hospitalSearch" :placeholder="content.selectKeyword" :clearable="false" @input="hospitalSearchInput"/>
      <div class="com-popup-p">
        <div v-if="hospitalSearch" class="com-popup-p-search">
          <div class="com-popup-p-item" v-html="highlightSearch(hospitalSearch, hospitalSearch)" @click="onHospitalConfirm(hospitalSearch)">
          </div>
          <div class="com-popup-p-item" v-for="(item, index) in hospitalList" :key="index" v-html="highlightSearch(item.name, hospitalSearch)" @click="onHospitalConfirm(item.name)">
          </div>
        </div>
        <div v-else class="com-popup-p-recommend">
          <div class="com-popup-p-item" v-for="(item, index) in hospitalRecommendList" :key="index" @click="onHospitalConfirm(item.hospital_name)">
            {{item.hospital_name}}
          </div>
        </div>
      </div>
    </van-popup>
    <!--职称选择框-->
    <van-popup
      v-model="showJobTitlePicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        :columns="jobTitleList"
        value-key="job_title"
        @confirm="onJobTitleConfirm"
        @cancel="showJobTitlePicker = false"
      />
    </van-popup>
    <!--学校选择框-->
    <van-popup
      v-model="showSchoolPicker"
      position="bottom"
    >
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="schoolCancel">{{content.becancel}}</button>
        <!-- <button type="button" class="van-picker__confirm"></button> -->
      </div>
      <van-search v-model="schoolSearch" :placeholder="content.selectKeyword" :clearable="false" @input="schoolSearchInput"/>
      <div class="com-popup-p">
        <div v-if="schoolSearch" class="com-popup-p-search">
          <div class="com-popup-p-item" v-for="(item, index) in schoolList" :key="index" v-html="highlightSearch(item.name, schoolSearch)" @click="onSchoolConfirm(item.name)">
          </div>
        </div>
        <div v-else class="com-popup-p-recommend">
          <div class="com-popup-p-item" v-for="(item, index) in schoolRecommendList" :key="index" @click="onSchoolConfirm(item.school)">
            {{item.school}}
          </div>
        </div>
      </div>
    </van-popup>
    <!--身份选择框-->
    <van-popup
      v-model="showEducationPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="educationList"
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        @confirm="onEducationConfirm"
        @cancel="showEducationPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { postRegister, postUpdateMyInfo, postIdentityList, getAuthJobTitles, getAuthOffices, getHospitalRecommend,
  getSchoolRecommend, getAuthHospitals, getAuthSchools } from '@/models/common'
import { debounce } from '@/utils/index.js'
export default {
  props: {
    phone: {
      type: [String, Number],
      default: ''
    },
    dataForm: {
      type: Object,
      default: function () {
        return {
          type: '',
          name: '',
          hospital_name: '',
          hospital_offices: '',
          job_title: '',
          password: '',
          passwordModify: '',
          school: '',
          specialty: '',
          education: '',
          work_unit: '',
          post: '',
        }
      }
    },
    canClose: {
      // 是否允许关闭
      type: Boolean,
      default: false
    }
  },
  computed: {
    validForm: function () {
      if(this.lanuage == 'Chinese'){
        if (['医生', '护士', '医技', '药师'].includes(this.perfectForm.type)) {
          return (this.perfectForm.name?.trim() && this.perfectForm.hospital_name?.trim() && this.perfectForm.hospital_offices?.trim() && this.perfectForm.job_title?.trim())
        } else if (['医学生'].includes(this.perfectForm.type)) {
          return (this.perfectForm.name?.trim() && this.perfectForm.school?.trim() && this.perfectForm.specialty?.trim() && this.perfectForm.education?.trim())
        } else if (['其他医务从业者', '非医务从业者'].includes(this.perfectForm.type)) {
          return (this.perfectForm.name?.trim() && this.perfectForm.work_unit?.trim() && this.perfectForm.post?.trim())
        } else{
          return false
        }
      }else {
        // 非中文版只允许输入姓名、医院、科室
        return (this.perfectForm.name?.trim() && this.perfectForm.hospital_name?.trim() && this.perfectForm.hospital_offices?.trim())
      }
    },
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  data() {
    return {
      perfectShow: false, // 完善弹框
      perfectForm: { // 完善框表单
        type: '',
        code: 0,
        name: '',
        hospital_name: '',
        hospital_offices: '',
        job_title: '',
        school: '',
        specialty: '',
        education: '',
        work_unit: '',
        post: '',
      },
      passwordErrorMessage: '',
      passwordModiErrorMessage: '',
      showPicker: false,
      columns: [], //身份 1001：医生1002：护士1003：医技1004：药师1005：医学生1006：其他医务从业者1007：非医务从业者
      showHospitalPicker: false, // 医院选择器
      hospitalSearch: '', // 医院关键词
      hospitalList: [], // 医院列表
      hospitalRecommendList: [], // 推荐医院列表
      pcHospitalColumns: [], // pc端的下拉医院列表
      pcHospitalLoading: false, // 远程搜索的医院下拉框loading
      showOfficesPicker: false, // 科室选择器
      officesList: [], // 科室列表
      officesLastList: [], // 科室最后一级列表，用于协助级联框回显
      officesFormData: '', // pc端科室级联回显项
      showJobTitlePicker: false, // 职称选择器
      jobTitleList: [], // 职称列表
      showSchoolPicker: false, // 学校选择器
      schoolSearch: '', // 学校关键词
      schoolList: [], // 学校列表
      schoolRecommendList: [], // 推荐学校列表
      pcSchoolColumns: [], // pc端的下拉学校列表
      pcSchoolLoading: false, // 远程搜索的学校下拉框loading
      showEducationPicker: false, // 学历选择器
      educationList: [
        '博士', '硕士', '本科', '大专', '高中/中专'
      ], // 学历列表
    }
  },
  watch: {
    'dataForm': function (form) {
      this.perfectForm = Object.assign(this.perfectForm, { ...form })
      if(this.isPc){
        if(this.officesLastList.length > 0 && this.perfectForm.hospital_offices) {
          let obj = this.officesLastList.filter(item=>{
            return item.label == this.perfectForm.hospital_offices
          })
          if(obj.length > 0) {
            this.officesFormData = [obj[0].parent_id, obj[0].value]
          }
        }
      }
    },
    'perfectForm.code': function(val) {
      // this.perfectForm.job_title = ''
      this.getJobTitles(val)
    }
  },
  mounted(){
    console.log('进入完善资料',)
    // 初始化身份列表
    postIdentityList().then(res => {
      if(res.data.code == 0) {
        this.columns = res.data.data
        // console.log(res.data);
        this.perfectForm.type = this.columns[0].name
        this.perfectForm.code = this.columns[0].code
      }
    })
    if(this.isPc){

      this.getOffices().then(async (data) => {
        // 初步映射办公室数据
        let arr = data.map(v => {
          return {
            label: v.title,
            value: v.id,
            children: []
          }
        });

        // 异步获取每个办公室的子级数据
        const getChildrenForOffice = async (office) => {
          let childrenData = await this.getOffices(office.value);
          office.children = childrenData.map(v => {
            return {
              label: v.title,
              value: v.id,
            }
          });
          return childrenData.map(v => {
            return {
              parent_id: v.parent_id,
              label: v.title,
              value: v.id,
            }
          });
        };

        // 使用 Promise.all 等待所有异步操作完成
        let lastLevelList = await Promise.all(arr.map(getChildrenForOffice)).then(results => {
          // 将所有结果扁平化为一个数组
          return results.flat();
        });

        // 更新办公室列表
        this.officesList = arr;
        this.officesLastList = lastLevelList;

        if (this.officesLastList.length > 0 && this.perfectForm.hospital_offices) {
          let obj = this.officesLastList.filter(item => {
            return item.label == this.perfectForm.hospital_offices;
          });
          if (obj.length > 0) {
            this.officesFormData = [obj[0].parent_id, obj[0].value];
          }
        }
      });
    }
    else {
      // 初始化一级科室
      this.getOffices().then((data)=>{
        this.officesList = [{values: data}, {values: []}]
        if(data.length > 0) {
          this.getOffices(data[0].id).then((data)=>{
            this.officesList[1].values = data
          })
        }
      })
    }
    // 初始化医院推荐
    getHospitalRecommend().then(res=>{
      if(res.data.code == 0){
        this.hospitalRecommendList = res.data.data
        if(this.isPc){
          this.pcHospitalColumns = res.data.data.map(v => v.hospital_name)
        }
      }
    })
    // 初始化学校推荐
    getSchoolRecommend().then(res=>{
      if(res.data.code == 0){
        this.schoolRecommendList = res.data.data
        if(this.isPc){
          this.pcSchoolColumns = res.data.data.map(v => v.school)
        }
      }
    })
  },
  methods: {
    // pc-选择身份
    pcTypeChange(e){
      this.perfectForm.code = e
      this.perfectForm.type = this.columns.filter(item => {
        return item.code == e
      })[0].name
    },
    // pc-搜索医院
    pcHospitalRemoteMethod(query){
      const _this = this
      if (query !== '') {
        this.pcHospitalLoading = true
        debounce(()=>{
          getAuthHospitals({
            keyword: query
          }).then(res=>{
            if(res.data.code == 0) {
              _this.pcHospitalLoading = false
              _this.pcHospitalColumns = res.data.data.map(v => v.name)
            }
          })
        }, 1000)()
      } else {
        this.pcHospitalLoading = false
        this.pcHospitalColumns = this.hospitalRecommendList.map(v => v.hospital_name)
      }
    },
    // pc-医院下拉框在获取焦点时，如果没选值，则初始化推荐的医院
    pcHospitalFocus(){
      if(this.perfectForm.hospital_name == ''){
        this.pcHospitalColumns = this.hospitalRecommendList.map(v => v.hospital_name)
      }
    },
    // pc-医院下拉框清空方法
    pcHospitalClear(){
      this.pcHospitalFocus()
    },
    // pc-所在科室的级联框变更
    selectOfficeChange(e){
      if(this.officesLastList.length > 0) {
        let obj = this.officesLastList.filter(item=>{
          return item.value == e[1]
        })
        if(obj.length > 0) {
          this.perfectForm.hospital_offices = obj[0].label
        }
      }
    },
    // pc-搜索学校
    pcSchoolRemoteMethod(query){
      const _this = this
      if (query !== '') {
        this.pcSchoolLoading = true
        debounce(()=>{
          getAuthSchools({
            name: query
          }).then(res=>{
            if(res.data.code == 0) {
              _this.pcSchoolLoading = false
              _this.pcSchoolColumns = res.data.data.map(v => v.name)
            }
          })
        }, 1000)()
      } else {
        this.pcSchoolLoading = false
        this.pcSchoolColumns = this.schoolRecommendList.map(v => v.school)
      }
    },
    // pc-学校下拉框在获取焦点时，如果没选值，则初始化推荐的学校
    pcSchoolFocus(){
      if(this.perfectForm.school == ''){
        this.pcSchoolColumns = this.schoolRecommendList.map(v => v.school)
      }
    },
    // pc-学校下拉框清空方法
    pcSchoolClear(){
      this.pcSchoolFocus()
    },
    // 关闭弹窗
    closeDialog() {
      this.perfectShow = false
    },
    // 完善资料弹窗
    showDialog() {
      this.perfectShow = true
    },
    // 获取职称列表
    getJobTitles(code){
      getAuthJobTitles({
        identity_no: code
      }).then(res=>{
        if(res.data.code == 0) {
          this.jobTitleList = res.data.data
        }
      })
    },
    // 获取科室列表
    getOffices(pId = 0) {
      // console.log('获取科室列表-----','perfect-dialog')
      return new Promise((resolve, reject)=>{
        getAuthOffices({
          parent_id: pId
        }).then(res=>{
          if(res.data.code == 0) {
            resolve(res.data.data)
          }else {
            reject(res.data.data)
          }
        })
      })
    },
    // 选中身份
    onConfirm(value) {
      this.perfectForm.type = value.name
      this.perfectForm.code = value.code
      this.showPicker = false
    },
    // 搜索医院
    hospitalSearchInput(){
      const _this = this
      debounce(()=>{
        if(_this.hospitalSearch) {
          getAuthHospitals({
            keyword: _this.hospitalSearch
          }).then(res=>{
            if(res.data.code == 0) {
              _this.hospitalList = res.data.data
            }
          })
        }
      }, 1000)()
    },
    // 选中医院
    onHospitalConfirm(name){
      this.perfectForm.hospital_name = name
      this.showHospitalPicker = false
    },
    // 取消医院弹出框
    hospitalCancel(){
      this.hospitalSearch = ''
      this.hospitalList = []
      this.showHospitalPicker = false
    },
    // 选中科室
    onOfficesConfirm(value){
      this.perfectForm.hospital_offices = value[1].title
      this.showOfficesPicker = false
    },
    // 科室选择变更事件
    onOfficesChange(picker, values) {
      // console.log(values);
      if(values[0].parent_id == 0){
        this.getOffices(values[0].id).then(data=>{
          picker.setColumnValues(1, data);
        })
      }
    },
    // 选中职称
    onJobTitleConfirm(value){
      this.perfectForm.job_title = value.job_title
      this.showJobTitlePicker = false
    },
    // 选中学历
    onEducationConfirm(value){
      this.perfectForm.education = value
      this.showEducationPicker = false
    },
    // 搜索学校
    schoolSearchInput(){
      const _this = this
      debounce(()=>{
        if(_this.schoolSearch) {
          getAuthSchools({
            name: _this.schoolSearch
          }).then(res=>{
            if(res.data.code == 0) {
              _this.schoolList = res.data.data
            }
          })
        }
      }, 1000)()
    },
    // 选中学校
    onSchoolConfirm(name){
      this.perfectForm.school = name
      this.showSchoolPicker = false
    },
    // 取消学校弹出框
    schoolCancel(){
      this.schoolSearch = ''
      this.schoolList = []
      this.showSchoolPicker = false
    },
    // 完善资料页按钮
    perfectBtn() {
      const _this = this
      const form = {
        member: {
          name: this.perfectForm.name,
          hospital_name: this.perfectForm.hospital_name,
          hospital_offices: this.perfectForm.hospital_offices,
          job_title: this.perfectForm.job_title,
          school: this.perfectForm.school,
          specialty: this.perfectForm.specialty,
          education: this.perfectForm.education,
          work_unit: this.perfectForm.work_unit,
          post: this.perfectForm.post,
        },
        member_id: this.perfectForm.member_id
      }
      switch (this.perfectForm.type) {
        case '医生':
          form.type = 1001;
          break;
        case '护士':
          form.type = 1002;
          break;
        case '医技':
          form.type = 1003;
          break;
        case '药师':
          form.type = 1004;
          break;
        case '医学生':
          form.type = 1005;
          break;
        case '其他医务从业者':
          form.type = 1006;
          break;
        case '非医务从业者':
          form.type = 1007;
          break;
        default:
          break;
      }
      postUpdateMyInfo(form).then(res => {
        if (res.data.code == 0) {
          // 如果从登录来但需要完善资料的，需完善资料后才自动记录memberId，下次自动登录
          localStorage.setItem('loginItem', JSON.stringify({ userId: this.perfectForm.member_id }))
          _this.$toast(_this.content.perfectSuccess)
          _this.perfectShow = false
          this.resetForm()
          this.$emit('perfectSuccess', { id: this.perfectForm.member_id })
        } else {
          _this.$toast(_this.content.perfectFail)
          this.$emit('perfectFail')
        }
      })
    },
    highlightSearch(name, key) {
      return name.replace(key, `<span class="search">${key}</span>`)
    },
    // 完善资料页按钮（弃用）
    perfectBtn1() {
      const _this = this
      // if (!/^[a-zA-Z0-9]{6,15}$/.test(this.perfectForm.password)) {
      //   this.passwordErrorMessage = '仅限6-15位字母、数字'
      //   return
      // } else {
      //   this.passwordErrorMessage = ''
      // }
      // if (this.perfectForm.passwordModify != this.perfectForm.password) {
      //   this.passwordModiErrorMessage = '两次输入密码不一致'
      //   return
      // } else {
      //   this.passwordModiErrorMessage = ''
      // }
      postRegister({
        member_id: this.perfectForm.member_id,
        phone: String(this.phone).trim(),
        name: String(this.perfectForm.name).trim(),
        hospital_name: String(this.perfectForm.hospital_name).trim(),
        hospital_offices: String(this.perfectForm.hospital_offices).trim(),
        job_title: String(this.perfectForm.job_title).trim(),
        // password: String(this.perfectForm.password).trim(),
      }).then(async res => {
        if (res.data.code == 0) {
          _this.$toast(_this.content.perfectSuccess)
          _this.perfectShow = false
          this.resetForm()
          this.$emit('perfectSuccess', { id: res.data.data.id })
          // 拿到conventionId
          // if (_this.$route.query.conventionId) {
          //   const res1 = await postCheckLoginPay({
          //     convention_id: _this.$route.query.conventionId,
          //     member_id: res.data.data.id,
          //   })
          //   if (res1.data.code == 0) {
          //     if (res1.data.data.is_allow_live) {
          //       // 可观看，跳转直播页面
          //       _this.$router.replace({
          //         path: '/chat-online',
          //         query: {
          //           memberId: res.data.data.id,
          //           room: _this.$route.query.room,
          //           conventionId: _this.$route.query.conventionId
          //         }
          //       })
          //     } else {
          //       // 不可观看
          //       _this.$toast('很抱歉，您没有直播观看权限')
          //     }
          //   } else {
          //     _this.$toast('获取直播观看权限失败，请稍后再试');
          //   }
          // } else {
          //   setTimeout(() => {
          //     _this.$router.replace({
          //       path: '/chat-online',
          //       query: {
          //         memberId: res.data.data.id,
          //         room: _this.$route.query.room,
          //         conventionId: _this.$route.query.conventionId
          //       }
          //     })
          //   }, 400)
          // }
        } else {
          _this.$toast(_this.content.perfectFail)
          this.$emit('perfectFail')
        }
      })
    },
    // 密码输入框
    passwordInput() {
      if (this.perfectForm.password) {
        if (!/^[a-zA-Z0-9]{6,15}$/.test(this.perfectForm.password)) {
          this.passwordErrorMessage = '仅限6-15位字母、数字'
        } else {
          this.passwordErrorMessage = ''
        }
      } else {
        this.passwordErrorMessage = ''
      }
    },
    // 确认密码输入框
    passwordModiInput() {
      if (this.perfectForm.passwordModify) {
        if (this.perfectForm.passwordModify != this.perfectForm.password) {
          this.passwordModiErrorMessage = '两次输入密码不一致'
        } else {
          this.passwordModiErrorMessage = ''
        }
      } else {
        this.passwordModiErrorMessage = ''
      }
    },
    // 重置
    resetForm() {
      this.perfectForm = { // 完善框表单
        type: this.columns[0].name,
        code: this.columns[0].code,
        name: '',
        hospital_name: '',
        hospital_offices: '',
        job_title: '',
        school: '',
        specialty: '',
        education: '',
        work_unit: '',
        post: '',
      }
    },
    test(){
      if(this.isPc){
        this.getOffices().then((data)=>{
          let arr = data.map(v=>{
            return {
              label: v.title,
              value: v.id,
              children: []
            }
          })
          //问题出在，获取到的数组，但是先执行了上面在执行的下面
          let lastLevelList = [];
          for(let i=0;i<arr.length;i++){
            this.getOffices(data[i].id).then((data)=>{
              arr[i].children = data.map(v=>{
                return {
                  label: v.title,
                  value: v.id,
                }
              })
              lastLevelList.push(...data.map(v=>{
                return {
                  parent_id: v.parent_id,
                  label: v.title,
                  value: v.id,
                }
              }))
            })

          }
          this.officesList = arr;
          this.officesLastList = lastLevelList;

          console.log(this.officesList,this.officesList.length)
          console.log(this.officesLastList,this.officesLastList.length)

          if(this.officesLastList.length > 0 && this.perfectForm.hospital_offices) {
            console.log('取到数据进入循环赋值阶段')
            let obj = this.officesLastList.filter(item=>{
              return item.label == this.perfectForm.hospital_offices
            })
            if(obj.length > 0) {
              console.log('赋值')
              this.officesFormData = [obj[0].parent_id, obj[0].id]
            }
          }
        })
      }
    },
  }
}
</script>
<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.van-dialog {
  border-radius: 6px;
}
.perfect-container {
  .perfect-content-pc {
    // height: 4.5rem;
    padding: 0 0.35rem;
    .login-form-p{
      padding: 0 0.4rem;
    }
    .el-select{
      width: 100%;
    }
    .el-cascader{
      width: 100%;
    }
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;
    }
    .close-icon {
      position: absolute;
      top: 0.33rem;
      right: 0.3rem;
      cursor: pointer;
    }
    .van-cell {
      // margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .perfect-tip{
      color: #C0C4CC;
      font-size: 0.18rem;
    }
    .perfectBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.25rem auto 0.25rem;
      display: block;
    }
  }
  .perfect-content {
    // height: 4.5rem;
    padding: 0 0.25rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
    }
    .close-icon {
      position: absolute;
      top: 0.23rem;
      right: 0.23rem;
      cursor: pointer;
    }
    .van-cell {
      // margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .perfect-tip{
      font-size: 0.14rem;
      margin-top: 0.2rem;
      color: #C0C4CC;
    }
    .perfectBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.25rem auto 0.45rem;
      display: block;
    }
  }
  .van-popup{
    position: absolute;
  }
  .com-popup-p{
    height: 4rem;
    overflow-x: hidden;
    overflow-y: auto;
    padding-left: 0.23rem;
    padding-right: 0.23rem;
    padding-bottom: calc(env(safe-area-inset-bottom));
    .com-popup-p-search{}
    .com-popup-p-recommend{}
    .com-popup-p-item{
      padding: 0.13rem 0;
      font-size: 0.2rem;
      color: #AAAAAA;
      cursor: pointer;
      &:not(:first-child){
        border-top: 1px solid #E5E5E5;
      }
    }
    /deep/.search{
      color: #45A5E6;
    }
  }
}
</style>
